// Worked examples for Learning Value. Illustrative: invented decisions and costs.
// Addressable as #example=<id>.

import { methodById } from "./methods.js";

const m = (id, days) => {
  const p = methodById(id);
  return { label: p.label, preset: id, noise: p.noise, bias: p.bias, days };
};

export const EXAMPLES = [
  {
    id: "team-plan",
    name: "Team plan for a B2B startup",
    description: "Could earn a lot or flop; agents can prototype it in two days. Illustrative.",
    state: {
      decision: "Build a team plan",
      unit: "€k",
      dayValue: 0.6,
      value: { low: -30, high: 60 },
      methods: [m("interviews", 4), m("fake-door", 2), m("prototype", 2), m("beta", 10), m("before-after", 1)],
    },
  },
  {
    id: "clear-win",
    name: "A clear win",
    description: "Every plausible outcome is positive: learning cannot change the call. Illustrative.",
    state: {
      decision: "Add CSV export",
      unit: "€k",
      dayValue: 0.6,
      value: { low: 4, high: 12 },
      methods: [m("interviews", 3), m("fake-door", 1)],
    },
  },
  {
    id: "pricing-change",
    name: "Pricing change with a random rollout",
    description: "A random rollout by account is possible without an A/B tool. Illustrative.",
    state: {
      decision: "Raise prices 15%",
      unit: "€k",
      dayValue: 0.8,
      value: { low: -40, high: 50 },
      methods: [m("staged-random", 5), m("before-after", 1), m("interviews", 4)],
    },
  },
];

export function exampleById(id) {
  return EXAMPLES.find((e) => e.id === id) ?? null;
}
